import { Injectable, inject } from '@angular/core';
import { TenantComponentsState } from '../../states/tenant-components.state';
import { GetTenantComponentsStateResult } from './get-tenant-components-state.result';

/**
 * Get Tenant Components State Use Case.
 *
 * Provides read-only access to the tenant's product component signals. Use this
 * in the presentation layer instead of injecting TenantComponentsState directly.
 * To hydrate the state, use LoadTenantComponentsUseCase.
 */
@Injectable({ providedIn: 'root' })
export class GetTenantComponentsStateUseCase {
  private readonly _state = inject(TenantComponentsState);

  public execute(): GetTenantComponentsStateResult {
    return {
      sharedServicesPortalEnabled: this._state.sharedServicesPortalEnabled,
      employeeRelationsPortalEnabled: this._state.employeeRelationsPortalEnabled,
      employeePortalEnabled: this._state.employeePortalEnabled,
    };
  }
}
